module.exports = __webpack_public_path__ + "static/media/saverpacific-logo.7ad3d906.svg";